'use strict';

exports.__esModule = true;
exports.themes = undefined;

var _darkBaseTheme = require('material-ui/styles/baseThemes/darkBaseTheme');

var _darkBaseTheme2 = _interopRequireDefault(_darkBaseTheme);

var _lightBaseTheme = require('material-ui/styles/baseThemes/lightBaseTheme');

var _lightBaseTheme2 = _interopRequireDefault(_lightBaseTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var themes = exports.themes = [{
  id: 'light',
  source: _lightBaseTheme2.default
}, {
  id: 'dark',
  source: _darkBaseTheme2.default
}];

var getThemeSource = function getThemeSource(t, ts) {
  if (ts) {
    for (var i = 0; i < ts.length; i++) {
      if (ts[i]['id'] === t) {
        return ts[i]['source'];
      }
    }
  }

  return _lightBaseTheme2.default; // Default theme
};

exports.default = getThemeSource;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rmw-shell/lib/themes/index.js
// module id = 133
// module chunks = 49